import { URL } from './endpoints'
import { submitToApi } from 'awsApi'

export const ACTIONS = {
    GET_LIST: {
        SUCCESS: 'GET_LIST SUCCESS',
        FAILURE: 'GET_LIST FAILURE',
    },
    GET_GOALS_LIST: {
        START: 'GET_GOALS_LIST START',
        SUCCESS: 'GET_GOALS_LIST SUCCESS',
        FAILURE: 'GET_GOALS_LIST FAILURE',
    },
}

export const getList = query => async dispatch => {
    try {
        const { payload } = await submitToApi({
            method: 'GET',
            path: URL.DIRECTORY.V3_DIRECTORY_LABELS_RETRIEVE,
            query,
            url: URL.DIRECTORY.BASE,
        })
        dispatch({ type: ACTIONS.GET_LIST.SUCCESS, payload: { ...query, list: payload.data } })
    } catch (error) {
        dispatch({ type: ACTIONS.GET_LIST.FAILURE, error })
    }
}

export const getGoalTagsList = () => async dispatch => {
    dispatch({ type: ACTIONS.GET_GOALS_LIST.START })
    try {
        const { payload } = await submitToApi({
            path: URL.DIRECTORY.V3_DIRECTORY_LABELS_RETRIEVE,
            query: { field: 'goalTags' }, // active: true
            url: URL.DIRECTORY.BASE,
        })
        dispatch({ type: ACTIONS.GET_GOALS_LIST.SUCCESS, goalTags: payload.data }) // !Show users only active goalsTags `value.filter(({ active = true }) => active)`
    } catch (error) {
        dispatch({ type: ACTIONS.GET_GOALS_LIST.FAILURE, error })
    }
}
